import { getApiBase, setApiBase } from "./apiBase";

const LS_KEY = "respina_geo_config_v1";

export function getGeoConfig() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setGeoConfig(cfg) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(cfg || null));
  } catch {
    // ignore
  }
}

async function tryFetchWithTimeout(url, { timeoutMs = 800 } = {}) {
  const ac = new AbortController();
  const t = setTimeout(() => ac.abort(), timeoutMs);
  try {
    return await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
      signal: ac.signal,
    });
  } finally {
    clearTimeout(t);
  }
}

async function autoDetectApiBase() {
  if (typeof window === "undefined" || !window.location?.hostname) return null;
  const host = window.location.hostname;
  const start = Number(process.env.VUE_APP_API_PORT_START || 3100);
  const end = Number(process.env.VUE_APP_API_PORT_END || 3120);

  for (let port = start; port <= end; port += 1) {
    const base = `http://${host}:${port}`;
    try {
      const res = await tryFetchWithTimeout(`${base}/health`, { timeoutMs: 700 });
      if (!res.ok) continue;
      const data = await res.json().catch(() => null);
      if (data?.ok) return base;
    } catch {
      // ignore and try next port
    }
  }
  return null;
}

function detectOs() {
  try {
    const ua = navigator.userAgent || "";
    if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
    if (/Android/i.test(ua)) return "android";
  } catch {
    // ignore
  }
  return "";
}

export async function fetchGeoConfig() {
  let base = getApiBase().replace(/\/+$/, "");
  const os = detectOs();
  const osParam = os ? `?os=${os}` : "";
  const configUrl = `${base}/api/geo/config${osParam}`;
  try {
    const ac = new AbortController();
    const timeoutId = setTimeout(() => ac.abort(), 15000);
    const res = await fetch(configUrl, {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "omit",
      signal: ac.signal,
    });
    clearTimeout(timeoutId);
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`geo/config failed (${res.status}): ${text || res.statusText}`);
    }
    const data = await res.json();
    setGeoConfig(data);
    return data;
  } catch (e) {
    // If API base is wrong (common on LAN/mobile or when backend fell back to another port),
    // try to auto-detect the backend via /health, then retry once.
    const detected = await autoDetectApiBase();
    if (detected && detected !== base) {
      setApiBase(detected);
      base = detected;
      const retryUrl = `${base}/api/geo/config${osParam}`;
      const ac2 = new AbortController();
      const t2 = setTimeout(() => ac2.abort(), 15000);
      const res2 = await fetch(retryUrl, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "omit",
        signal: ac2.signal,
      });
      clearTimeout(t2);
      if (!res2.ok) {
        const text = await res2.text().catch(() => "");
        throw new Error(`geo/config failed (${res2.status}): ${text || res2.statusText}`);
      }
      const data2 = await res2.json();
      setGeoConfig(data2);
      return data2;
    }
    throw e;
  }
}

